module.exports = __webpack_public_path__ + "static/img/newDev.4790621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newDev.png
// module id = VXIQ
// module chunks = 29